class FavoriteStoreSelect {
	constructor( favoriteStoreEl ) {
		this.favoriteStoreEl = favoriteStoreEl;
		this.selectEl = favoriteStoreEl.querySelector( '.o-select__field' );
		this.locationEl = favoriteStoreEl.querySelector( '.o-select__favorite-store' );
		this.noLocationEl = favoriteStoreEl.querySelector( '.o-select__favorite-nostore' );
		this.logoEl = favoriteStoreEl.querySelector( '.o-select__favorite-store-logo' );
		this.addressEl = favoriteStoreEl.querySelector( '.o-select__favorite-store-address' );

		// Detect user clicks on the summary element
		this.selectEl.addEventListener( 'change', ( ev ) => this.onChange( ev ) );
	}

	onChange( ev ) {
		// Stop default behaviour from the browser
		ev.preventDefault();

		// Show/hide info of location
		this.locationEl.classList.toggle( 'en_hidden', ev.srcElement.value === '' );
		this.noLocationEl.classList.toggle( 'en_hidden', ev.srcElement.value !== '' );

		// Update address value with the data attribute of the current selected option if value not empty string
		if( ev.srcElement.value !== '' ) {
			this.logoEl.classList.remove( 'o-select__favorite-store-logo--koe', 'o-select__favorite-store-logo--gigasport' );
			this.logoEl.classList.add( 'o-select__favorite-store-logo--' + this.selectEl.options[this.selectEl.selectedIndex].getAttribute( 'data-location-logo' ) );
			this.addressEl.innerHTML = this.selectEl.options[this.selectEl.selectedIndex].getAttribute( 'data-location-description' );
		}
	}

}

const initFavoriteStoreSelect = ( scopeEl = document ) => {
	scopeEl.querySelectorAll( '.o-select--favorite-store' ).forEach( ( favoriteStoreEl ) => {
		favoriteStoreEl.SL_FavoriteStoreSelect ??= new FavoriteStoreSelect( favoriteStoreEl );
	} );
}

export {
	FavoriteStoreSelect as default,
	initFavoriteStoreSelect
};
